__webpack_require__.p = "https://svum.canary.perfectstay.io/static/";